import axios from "axios";
import { routeMapperFunction } from "../../utils/routeUtils";
import axiosInstance from "../../translator";
import { userAuthenticationAPI as userAuth } from "../../constants/apis/apiEndpoints";
import { translator } from "../../constants/actionTypes";

export const fetchData = async () => {
  let save = [];
  await fetch("https://api.ipify.org?format=json")
    .then((response) => response.json())
    .then((json) => (save = json));
  return save;
};

export const getResourceData = async () => {
  let mapRoute = "";
  await fetch("http://localhost:3000/resource_permissions")
    .then((response) => response.json())
    .then((json) => {
      mapRoute = routeMapperFunction(json);
    });
  return mapRoute;
};

export const signOutUser = async (payload) => {
  return axiosInstance
    .post(`${userAuth.logoutEndpoint}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getLoginDeatails = async (payload) => {
  return axios
    .post(`${translator?.baseURL}/${userAuth?.login}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getAuthTokenDetails = async (payload) => {
  return axios
    .post(`${translator?.baseURL}/${userAuth?.azureAdUrl}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const localUserSignup = async (payload) => {
  return axios
    .post(`${translator?.baseURL}/${userAuth?.signupB2cUser}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const localUserLogin = async (payload) => {
  return axios
    .post(`${translator?.baseURL}/${userAuth?.login}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const localUserForgotPassword = async (payload) => {
  return axios
    .post(`${translator?.baseURL}/${userAuth?.forgotPassword}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const localUserResetPassword = async (payload) => {
  return axios
    .post(`${translator?.baseURL}/${userAuth?.resetPassword}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getIdpAuthTokenApi = async (payload) => {
  return axios
    .post(`${translator?.baseURL}/${userAuth?.idpAuthEndpoint}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchLocalUserAccessToken = async (payload) => {
  let apiEndpoint = payload?.apiUrl;
  if (!apiEndpoint.endsWith("/")) {
    apiEndpoint = apiEndpoint + "/";
  }
  delete payload?.apiUrl;

  return axios
    .post(`${apiEndpoint}${userAuth?.fetchLocalUserAccessToken}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
